import { gql } from '@apollo/client';

export const TicketingProviderUserFragment = gql`
  fragment TicketingProviderUser on TicketingProviderUser {
    id
    fullName
    ticketingProvider
  }
`;
